import React from 'react';
import TermLengths from './FullUWCoverageLengths';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import PreQuote from '../../../../Quoters/PreQuote/PreQuote';
import IsHavenCampaign from './HavenCampaign';

export default function DigitalTermData(props) {
  const minAge = 18;
  const maxAge = 70;
  const minCoverageAmount = 100000;
  const maxCoverageAmount = 10000000;

  const isHavenCampaign = IsHavenCampaign();

  return {
    name: 'Term Life Insurance',
    subtitle: 'Click. Quote. Coverage.',
    footerMessage: "Get term insurance from start to finish completely online.",
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    basicInfoForm: (history) => {
      return <PreQuote
        HavenCampaign
        landing
        history={history}
        generalSpecs={
          {
            specs: {
              age: {
                min: minAge,
                max: maxAge,
              },
            }
          }}
      />;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [1, 2, 3],
    faq: FaqData()
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/DigitalTermData.js